import React from 'react';

const DownloadButtons = ({ googlePlayUrl, appStoreUrl, googlePlayBadgeUrl, appStoreBadgeUrl }) => (
  <div className="flex flex-row justify-center items-center space-x-4">
    <a href={googlePlayUrl} target="_blank" rel="noreferrer">
      <img src={googlePlayBadgeUrl} alt="Google Play Badge" />
    </a>
    <a href={appStoreUrl} target="_blank" rel="noreferrer">
      <img src={appStoreBadgeUrl} alt="App Store Badge" />
    </a>
  </div>
);

export default DownloadButtons;
